export default __webpack_public_path__ + "static/media/zoom-in-filled.2cf8b600.svg";